import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  type: "button",
  class: "disabled:opacity-75 disabled:cursor-not-allowed inline-flex items-center px-4 py-2 border border-transparent text-base font-medium rounded-md text-teal-800 bg-teal-200 hover:bg-teal-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
}
const _hoisted_2 = {
  key: 0,
  class: "animate-spin -ml-1 mr-3 h-5 w-5 text-teal-500",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("circle", {
  class: "opacity-25",
  cx: "12",
  cy: "12",
  r: "10",
  stroke: "currentColor",
  "stroke-width": "4"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  class: "opacity-75",
  fill: "currentColor",
  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: ["label", "loading"],
  setup(__props) {

const { label, loading } = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", _hoisted_1, [
    (__props.loading)
      ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5))
      : _createCommentVNode("", true),
    _createTextVNode(" " + _toDisplayString(__props.label), 1)
  ]))
}
}

})